/* 2:1 Fueling Line — scoped, dependency-free Shopify theme behavior. */

(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-e21-root]";

  /*
   * ============================================================
   * HELPERS
   * ============================================================
   */

  function shopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return "/";
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches
    );
  }


  /*
   * ============================================================
   * PRODUCT TABS
   * ============================================================
   */

  function setupProductTabs(root) {
    var tabs = Array.prototype.slice.call(
      root.querySelectorAll("[data-e21-tab]")
    );

    var panels = Array.prototype.slice.call(
      root.querySelectorAll("[data-e21-panel]")
    );

    if (!tabs.length || !panels.length) {
      return;
    }

    function activateTab(tab, moveFocus) {
      var panelId = tab.getAttribute("aria-controls");

      tabs.forEach(function (item) {
        var active = item === tab;

        item.classList.toggle("is-active", active);

        item.setAttribute(
          "aria-selected",
          active ? "true" : "false"
        );

        item.setAttribute(
          "tabindex",
          active ? "0" : "-1"
        );
      });

      panels.forEach(function (panel) {
        var active = panel.id === panelId;

        panel.classList.toggle(
          "is-active",
          active
        );

        panel.hidden = !active;
      });

      if (moveFocus) {
        tab.focus();
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener(
        "click",
        function () {
          activateTab(tab, false);
        }
      );

      tab.addEventListener(
        "keydown",
        function (event) {
          var targetIndex = index;

          if (
            event.key === "ArrowRight" ||
            event.key === "ArrowDown"
          ) {
            targetIndex =
              (index + 1) % tabs.length;

          } else if (
            event.key === "ArrowLeft" ||
            event.key === "ArrowUp"
          ) {
            targetIndex =
              (index - 1 + tabs.length) %
              tabs.length;

          } else if (
            event.key === "Home"
          ) {
            targetIndex = 0;

          } else if (
            event.key === "End"
          ) {
            targetIndex =
              tabs.length - 1;

          } else {
            return;
          }

          event.preventDefault();

          activateTab(
            tabs[targetIndex],
            true
          );
        }
      );
    });

    root.addEventListener(
      "shopify:block:select",
      function (event) {
        var panel = event.target.closest(
          "[data-e21-panel]"
        );

        if (!panel) {
          return;
        }

        var matchingTab =
          root.querySelector(
            '[aria-controls="' +
              panel.id +
              '"]'
          );

        if (matchingTab) {
          activateTab(
            matchingTab,
            false
          );
        }
      }
    );
  }


  /*
   * ============================================================
   * VARIANT SELECTS
   * ============================================================
   */

  function setupVariantSelects(root) {
    root
      .querySelectorAll(
        "[data-e21-variant-select]"
      )
      .forEach(function (select) {

        function syncVariant() {
          var option =
            select.options[
              select.selectedIndex
            ];

          var form = select.closest(
            "[data-e21-product-form]"
          );

          var productArea =
            select.closest(
              ".e21-product-panel, .e21-commerce-card"
            );

          var price =
            productArea &&
            productArea.querySelector(
              "[data-e21-price]"
            );

          var button =
            form &&
            form.querySelector(
              "[data-e21-add-button]"
            );

          var available =
            option &&
            option.getAttribute(
              "data-available"
            ) !== "false";

          if (
            price &&
            option &&
            option.getAttribute(
              "data-price"
            )
          ) {
            price.textContent =
              option.getAttribute(
                "data-price"
              );
          }

          if (button) {
            button.disabled =
              !available;
          }
        }

        select.addEventListener(
          "change",
          syncVariant
        );

        syncVariant();
      });
  }


  /*
   * ============================================================
   * CART HELPERS
   * ============================================================
   */

  function updateCartCount(itemCount) {
    if (
      typeof itemCount !== "number"
    ) {
      return;
    }

    var selectors = [
      ".header__cart-count",
      "[data-cart-count]",
      ".cart-count-bubble span:first-child",
      "#cart-icon-bubble .cart-count-bubble span:first-child"
    ];

    document
      .querySelectorAll(
        selectors.join(",")
      )
      .forEach(function (element) {
        element.textContent =
          String(itemCount);

        if (itemCount > 0) {
          element.removeAttribute(
            "hidden"
          );

          if (element.parentElement) {
            element.parentElement.removeAttribute(
              "hidden"
            );
          }
        }
      });
  }


  function fetchFreshCart() {
    return fetch(
      shopifyRoot() +
        "cart.js?e21=" +
        Date.now(),
      {
        method: "GET",

        credentials: "same-origin",

        cache: "no-store",

        headers: {
          Accept: "application/json",
          "Cache-Control": "no-cache"
        }
      }
    ).then(function (response) {
      if (!response.ok) {
        throw new Error(
          "Unable to fetch cart."
        );
      }

      return response.json();
    });
  }


  function fetchFreshMiniCart() {
    return fetch(
      shopifyRoot() +
        "cart?section_id=mini-cart&e21=" +
        Date.now(),
      {
        method: "GET",

        credentials: "same-origin",

        cache: "no-store",

        headers: {
          "Cache-Control": "no-cache"
        }
      }
    ).then(function (response) {
      if (!response.ok) {
        throw new Error(
          "Unable to refresh mini cart."
        );
      }

      return response.text();
    });
  }


  function refreshCartInBackground() {
    return Promise.all([
      fetchFreshCart(),
      fetchFreshMiniCart()
    ])
      .then(function (results) {
        var cart = results[0];
        var miniCartHtml = results[1];

        /*
         * ----------------------------------------
         * CART COUNT
         * ----------------------------------------
         */

        updateCartCount(
          cart.item_count
        );


        /*
         * ----------------------------------------
         * MINI CART HTML
         * ----------------------------------------
         *
         * We update the existing mini-cart
         * WITHOUT opening it.
         */

        var parser =
          document.createElement("div");

        parser.innerHTML =
          miniCartHtml;

        var freshMiniCart =
          parser.querySelector(
            ".mini-cart"
          );

        var currentMiniCart =
          document.querySelector(
            ".mini-cart"
          );

        if (
          freshMiniCart &&
          currentMiniCart
        ) {
          /*
           * IMPORTANT:
           *
           * Do NOT replace currentMiniCart itself,
           * because Warehouse already has JS
           * listeners attached to that element.
           *
           * Only replace its contents.
           */

          currentMiniCart.innerHTML =
            freshMiniCart.innerHTML;

          currentMiniCart.dispatchEvent(
            new CustomEvent(
              "cart:rerendered",
              {
                bubbles: true
              }
            )
          );
        }

        return cart;
      });
  }


  /*
   * ============================================================
   * PRODUCT FORMS / ADD TO CART
   * ============================================================
   */

  function setupProductForms(root) {
    root
      .querySelectorAll(
        "[data-e21-product-form]"
      )
      .forEach(function (form) {

        if (
          form.dataset.e21FormReady ===
          "true"
        ) {
          return;
        }

        form.dataset.e21FormReady =
          "true";


        /*
         * --------------------------------------------------------
         * IMPORTANT
         * --------------------------------------------------------
         *
         * Warehouse also has delegated click listeners for
         * add-to-cart buttons.
         *
         * We stop THIS custom E21 button click from bubbling
         * into Warehouse's add-to-cart handler.
         *
         * We DO NOT preventDefault here.
         *
         * That means browser still submits the form,
         * and our submit listener below handles it with AJAX.
         */

        form.addEventListener(
          "click",
          function (event) {
            var button =
              event.target.closest(
                "[data-e21-add-button]"
              );

            if (!button) {
              return;
            }

            event.stopPropagation();
          }
        );


        /*
         * --------------------------------------------------------
         * CUSTOM E21 AJAX ADD TO CART
         * --------------------------------------------------------
         */

        form.addEventListener(
          "submit",
          function (event) {

            /*
             * ABSOLUTELY DO NOT allow normal
             * form submission / redirect.
             */
            event.preventDefault();
            event.stopPropagation();


            if (
              !window.fetch ||
              !window.FormData
            ) {
              return;
            }


            var button =
              form.querySelector(
                "[data-e21-add-button]"
              );


            if (
              !button ||
              button.disabled
            ) {
              return;
            }


            var label =
              button.querySelector(
                "[data-e21-button-label]"
              );


            var status =
              form.querySelector(
                "[data-e21-cart-status]"
              );


            var defaultLabel =
              button.getAttribute(
                "data-default-label"
              ) ||
              (
                label
                  ? label.textContent
                  : "Add to cart"
              );


            var successLabel =
              button.getAttribute(
                "data-success-label"
              ) ||
              "Added";


            var productTitle =
              form.getAttribute(
                "data-product-title"
              ) ||
              "Product";


            /*
             * ----------------------------------------
             * LOADING
             * ----------------------------------------
             */

            button.disabled = true;

            button.setAttribute(
              "aria-busy",
              "true"
            );


            if (status) {
              status.textContent = "";
            }


            /*
             * ----------------------------------------
             * ADD PRODUCT
             * ----------------------------------------
             */

            fetch(
              shopifyRoot() +
                "cart/add.js",
              {
                method: "POST",

                credentials:
                  "same-origin",

                headers: {
                  Accept:
                    "application/json",

                  "X-Requested-With":
                    "XMLHttpRequest"
                },

                body:
                  new FormData(form)
              }
            )


              /*
               * ----------------------------------------
               * SHOPIFY RESPONSE
               * ----------------------------------------
               */

              .then(function (response) {
                return response
                  .json()
                  .then(function (data) {

                    if (!response.ok) {
                      throw new Error(
                        data.description ||
                        data.message ||
                        "Unable to add this item."
                      );
                    }

                    return data;
                  });
              })


              /*
               * ----------------------------------------
               * PRODUCT SUCCESSFULLY ADDED
               * ----------------------------------------
               */

              .then(function () {

                /*
                 * IMPORTANT:
                 *
                 * DO NOT:
                 *
                 * - redirect anywhere
                 * - open checkout
                 * - open mini cart
                 * - dispatch product:added
                 * - dispatch cart:refresh
                 *
                 * Just silently refresh cart HTML.
                 */

                return refreshCartInBackground();
              })


              /*
               * ----------------------------------------
               * CART REFRESHED
               * ----------------------------------------
               */

              .then(function () {

                if (label) {
                  label.textContent =
                    successLabel;
                }


                if (status) {
                  status.textContent =
                    productTitle +
                    " added to cart.";
                }


                window.setTimeout(
                  function () {

                    if (label) {
                      label.textContent =
                        defaultLabel;
                    }


                    button.disabled =
                      false;


                    button.removeAttribute(
                      "aria-busy"
                    );

                  },
                  1800
                );
              })


              /*
               * ----------------------------------------
               * ERROR
               * ----------------------------------------
               */

              .catch(function (error) {

                console.error(
                  "[E21] Add to cart failed:",
                  error
                );


                if (status) {
                  status.textContent =
                    error.message;
                }


                if (label) {
                  label.textContent =
                    defaultLabel;
                }


                button.disabled =
                  false;


                button.removeAttribute(
                  "aria-busy"
                );
              });
          }
        );
      });
  }


  /*
   * ============================================================
   * CAROUSEL
   * ============================================================
   */

  function setupCarousel(root) {
    var carousel =
      root.querySelector(
        "[data-e21-carousel]"
      );

    if (!carousel) {
      return;
    }


    var viewport =
      carousel.querySelector(
        "[data-e21-carousel-viewport]"
      );


    var track =
      carousel.querySelector(
        "[data-e21-carousel-track]"
      );


    var items =
      Array.prototype.slice.call(
        carousel.querySelectorAll(
          "[data-e21-carousel-item]"
        )
      );


    var previous =
      carousel.querySelector(
        "[data-e21-carousel-previous]"
      );


    var next =
      carousel.querySelector(
        "[data-e21-carousel-next]"
      );


    if (
      !viewport ||
      !track ||
      !items.length ||
      !previous ||
      !next
    ) {
      return;
    }


    function cardStep() {
      var first =
        items[0];


      var styles =
        window.getComputedStyle(
          track
        );


      var gap =
        parseFloat(
          styles.columnGap ||
          styles.gap ||
          "0"
        );


      return (
        first
          .getBoundingClientRect()
          .width +
        gap
      );
    }


    function updateControls() {
      var maxScroll =
        Math.max(
          0,
          viewport.scrollWidth -
            viewport.clientWidth -
            2
        );


      previous.disabled =
        viewport.scrollLeft <= 2;


      next.disabled =
        viewport.scrollLeft >=
        maxScroll;
    }


    function scrollByCard(
      direction
    ) {
      viewport.scrollBy({
        left:
          cardStep() *
          direction,

        behavior:
          prefersReducedMotion()
            ? "auto"
            : "smooth"
      });
    }


    previous.addEventListener(
      "click",
      function () {
        scrollByCard(-1);
      }
    );


    next.addEventListener(
      "click",
      function () {
        scrollByCard(1);
      }
    );


    viewport.addEventListener(
      "keydown",
      function (event) {

        if (
          event.key !==
            "ArrowLeft" &&
          event.key !==
            "ArrowRight"
        ) {
          return;
        }


        event.preventDefault();


        scrollByCard(
          event.key ===
            "ArrowRight"
            ? 1
            : -1
        );
      }
    );


    viewport.addEventListener(
      "scroll",
      updateControls,
      {
        passive: true
      }
    );


    window.addEventListener(
      "resize",
      updateControls
    );


    window.requestAnimationFrame(
      updateControls
    );
  }


  /*
   * ============================================================
   * FAQ
   * ============================================================
   */

  function setupFaq(root) {
    var items =
      Array.prototype.slice.call(
        root.querySelectorAll(
          ".e21-faq__item"
        )
      );


    items.forEach(
      function (item) {

        item.addEventListener(
          "toggle",
          function () {

            if (!item.open) {
              return;
            }


            items.forEach(
              function (other) {

                if (
                  other !== item
                ) {
                  other.open =
                    false;
                }

              }
            );

          }
        );

      }
    );
  }


  /*
   * ============================================================
   * ANCHORS
   * ============================================================
   */

  function setupAnchors(root) {
    root
      .querySelectorAll(
        'a[href^="#e21-"]'
      )
      .forEach(function (link) {

        link.addEventListener(
          "click",
          function (event) {

            var selector =
              link.getAttribute(
                "href"
              );


            var target =
              selector &&
              document.querySelector(
                selector
              );


            if (!target) {
              return;
            }


            event.preventDefault();


            target.scrollIntoView({
              behavior:
                prefersReducedMotion()
                  ? "auto"
                  : "smooth",

              block:
                "start"
            });


            if (
              window.history &&
              window.history.replaceState
            ) {
              window.history.replaceState(
                null,
                "",
                selector
              );
            }

          }
        );

      });
  }


  /*
   * ============================================================
   * REVEAL ANIMATIONS
   * ============================================================
   */

  function setupReveals(root) {
    var items =
      root.querySelectorAll(
        "[data-e21-reveal]"
      );


    if (
      !items.length ||
      prefersReducedMotion() ||
      !(
        "IntersectionObserver" in
        window
      )
    ) {

      items.forEach(
        function (item) {
          item.classList.add(
            "is-visible"
          );
        }
      );

      return;
    }


    var observer =
      new IntersectionObserver(
        function (entries) {

          entries.forEach(
            function (entry) {

              if (
                !entry.isIntersecting
              ) {
                return;
              }


              entry.target.classList.add(
                "is-visible"
              );


              observer.unobserve(
                entry.target
              );

            }
          );

        },
        {
          threshold: 0.15
        }
      );


    items.forEach(
      function (item) {
        observer.observe(
          item
        );
      }
    );
  }


  /*
   * ============================================================
   * INITIALIZATION
   * ============================================================
   */

  function initRoot(root) {
    if (
      !root ||
      root.dataset.e21Ready ===
        "true"
    ) {
      return;
    }


    root.dataset.e21Ready =
      "true";


    setupProductTabs(root);

    setupVariantSelects(root);

    setupProductForms(root);

    setupCarousel(root);

    setupFaq(root);

    setupAnchors(root);

    setupReveals(root);
  }


  function initAll(scope) {
    var context =
      scope || document;


    if (
      context.matches &&
      context.matches(
        ROOT_SELECTOR
      )
    ) {
      initRoot(context);
    }


    context
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach(
        initRoot
      );
  }


  /*
   * ============================================================
   * INITIAL PAGE LOAD
   * ============================================================
   */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initAll(document);
      }
    );

  } else {

    initAll(document);

  }


  /*
   * ============================================================
   * SHOPIFY THEME EDITOR
   * ============================================================
   */

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initAll(
        event.target
      );
    }
  );

})();